import item from '../CollectionItems/yellowBlueOrange';

export default {
  location: 'yellow-blue-orange',
  filename: 'yellow-blue-orange-rothko',
  title: item.name,
};
